import { equalFinderData } from "#ce/components/SpFinder/engine/finder-data";

function active(option) {
  return Boolean(option.type) && option.type !== "no";
}

/**
 * Returns the scheduling message a result without bookable slots shows. `multiple: true` asks for the
 * new- and returning-patient messages side by side. `text(key)` reads the finder results catalog.
 */
export function schedulingOptions(result, { showMultipleSchedulingTypes, text }) {
  if (result.scheduling_type == null) {
    return {};
  }

  const options = { new_patient: {}, returning_patient: {}, ...result.scheduling_type };
  const { new_patient: newPatient, returning_patient: returningPatient } = options;

  if (result.patientType === "new_patient") {
    return newPatient;
  }
  if (result.patientType === "returning_patient") {
    return returningPatient;
  }
  if (equalFinderData(newPatient, returningPatient)) {
    return newPatient;
  }
  if (
    showMultipleSchedulingTypes &&
    newPatient.type &&
    returningPatient.type &&
    newPatient.type !== returningPatient.type &&
    !(newPatient.type === "no" && !result.accepting_patients)
  ) {
    return { ...options, multiple: true };
  }
  if (
    newPatient.type &&
    returningPatient.type &&
    newPatient.type !== "no" &&
    newPatient.type === returningPatient.type
  ) {
    return result.accepting_patients === false ? returningPatient : newPatient;
  }
  if (active(returningPatient) && !active(newPatient)) {
    return { title: text("returning_patients"), ...returningPatient };
  }
  if (active(newPatient) && !active(returningPatient)) {
    return { title: text("new_patients"), ...newPatient };
  }
  if (newPatient.fallback) {
    return newPatient;
  }
  if (returningPatient.fallback) {
    return returningPatient;
  }
  if (newPatient.type === "no" && returningPatient.type === "no") {
    return returningPatient;
  }

  return {
    card_variant: text("link_to_profile_card_variant"),
    message: text("link_to_profile_message"),
    label: text("link_to_profile_label"),
    url: result.url,
  };
}
